import React from 'react'
import { useState, useEffect } from 'react';
function Header() {

    const [isNavVisible, setIsNavVisible] = useState(false);
    const [activeSection, setActiveSection] = useState('home');

    const toggleNav = () => {
        setIsNavVisible(!isNavVisible);
    };

    useEffect(() => {
        const handleScroll = () => {
            const sections = ['home', 'about-us', 'services', 'gallery', 'contact-us'];
            const scrollPosition = window.scrollY + 100;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const offsetTop = element.offsetTop;
                    const offsetBottom = offsetTop + element.offsetHeight;

                    if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Call once to set initial state

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (event) => {
        event.preventDefault(); // Prevent default anchor behavior
        const targetId = event.currentTarget.getAttribute("href"); // Get target section ID
        const targetPosition = document.querySelector(targetId).offsetTop; // Get target position
        const offset = 70; // Height of your sticky header, adjust as needed
        const scrollTarget = targetPosition - offset; // Calculate scroll position with offset

        // Close mobile menu after clicking
        setIsNavVisible(false);

        window.scrollTo({
            top: scrollTarget,
            behavior: 'smooth'
        });
    };

    return (
        <header>
            <div className="container">
                <img src='images/logo3.jpg' alt='Energy Corporation Logo' />
                <div 
                    className='hamburger-menu' 
                    onClick={toggleNav}
                    role="button"
                    aria-label="Toggle navigation menu"
                    aria-expanded={isNavVisible}
                    tabIndex={0}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            toggleNav();
                        }
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </div>
                <nav className={isNavVisible ? "nav-visible" : ""}>
                    <ul className="nav-bar">
                        <li>
                            <a 
                                href="#home" 
                                onClick={scrollToSection}
                                className={activeSection === 'home' ? 'active' : ''}
                            >
                                Home
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#about-us" 
                                onClick={scrollToSection}
                                className={activeSection === 'about-us' ? 'active' : ''}
                            >
                                About Us
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#services" 
                                onClick={scrollToSection}
                                className={activeSection === 'services' ? 'active' : ''}
                            >
                                Services
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#gallery" 
                                onClick={scrollToSection}
                                className={activeSection === 'gallery' ? 'active' : ''}
                            >
                                Gallery
                            </a>
                        </li>
                        <li>
                            <a 
                                href="#contact-us" 
                                onClick={scrollToSection}
                                className={activeSection === 'contact-us' ? 'active' : ''}
                            >
                                Contact Us
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    )
}

export default Header